import React, { useCallback, useRef, useState } from 'react';
import ListingAutoRulePickModal from '@/pages/ipe/workbench/modals/ListingAutoRulePickModal';
import { resolveListingAutoRuleForIngest } from '@/pages/ipe/workbench/utils/resolveListingAutoRuleForIngest';

/**
 * 带入本地商品库时的自动规则选择（支持多选；「仅带入」与规则互斥）。
 * @returns {{ resolveForIngest: () => Promise<{ proceed: boolean, listingAutoRuleId: number|null, listingAutoRuleIds: number[], bindListingAutoRule: boolean }>, pickModal: React.ReactNode }}
 */
export default function useListingAutoRulePick() {
  const [open, setOpen] = useState(false);
  const [rules, setRules] = useState([]);
  const [confirming, setConfirming] = useState(false);
  const resolverRef = useRef(null);

  const close = useCallback(() => {
    setOpen(false);
    setRules([]);
    setConfirming(false);
    const resolve = resolverRef.current;
    resolverRef.current = null;
    resolve?.(null);
  }, []);

  const pickModalFn = useCallback((enabledRules) => new Promise((resolve) => {
    resolverRef.current = resolve;
    setRules(enabledRules || []);
    setConfirming(false);
    setOpen(true);
  }), []);

  const resolveForIngest = useCallback(async () => {
    return resolveListingAutoRuleForIngest({ pickModal: pickModalFn });
  }, [pickModalFn]);

  const onConfirm = useCallback((result) => {
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setConfirming(false);
    setOpen(false);
    setRules([]);
    resolve?.(result || null);
  }, []);

  const pickModal = (
    <ListingAutoRulePickModal
      open={open}
      rules={rules}
      confirming={confirming}
      onCancel={close}
      onConfirm={onConfirm}
    />
  );

  return { resolveForIngest, pickModal };
}
